import { type default as CartesianAxisView } from 'echarts/lib/component/axis/CartesianAxisView';
import { type Text } from 'echarts/lib/util/graphic';
import type { AxisElementInfos, AxisElementType } from './types';

/**
 * 从 view 实例获取轴标签元素
 */
export function getAxisLabelEls(compView: CartesianAxisView) {
  const labelEls = [] as Text[];

  compView.group.traverse(childEl => {
    if ((childEl.anid || '').startsWith('label_')) {
      labelEls.push(childEl as Text);
    }
  });

  return labelEls;
}

export const axisElementInfo: AxisElementInfos = {
  axisLine: anid => anid === 'line',
  axisLabel: anid => anid.startsWith('label_'),
  axisTick: anid => anid.startsWith('ticks_'),
  nameTextStyle: anid => anid === 'name',
  splitLine: anid => anid.startsWith('line_'),
  splitArea: anid => anid.startsWith('area_'),
  minorSplitLine: anid => anid.startsWith('minor_line_'),
  minorTick: anid => anid.startsWith('minorticks_')
};

/**
 * 为了坐标轴里各个部分的zr元素对应的echarts类型。
 * @description 因为dvZ配置项需要根据元素所属的类型（轴标签、轴线等）设置图形元素的层级,
 * 但是zr元素属于视图层，没有echarts里axisLabel、axisLine的概念，
 * 所以需要这样一个根据zr元素id确定其类型的方法
 */
export class AxisElementTypeDispatcher {
  types: AxisElementType[];

  constructor() {
    this.types = Object.keys(axisElementInfo) as AxisElementType[];
  }

  getElementType(anid: string) {
    let elType: AxisElementType;
    this.types.forEach(type => {
      if (axisElementInfo[type](anid)) {
        elType = type;
      }
    });
    return elType;
  }
}
